import { CreateChannelEventPayload } from 'models/ChannelEvent'

interface Data {
  items?: unknown[]
  donation_amount?: number
  amount?: number
  currency?: string
  donation_frequency?: string
  title?: string
}

const getCookie = (name: string) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    const cookieValue = parts.pop()

    if (cookieValue) {
      return cookieValue.split(';').shift()
    }
  }

  return undefined
}

const calculateNumOfItems = (data: Data) =>
  (data.items?.length || 0) + (data.donation_amount ? 1 : 0)

const getEventTime = () => Math.round(new Date().getTime() / 1000)
const generateEventId = () => `${getEventTime()}.${Math.floor(Math.random() * 1000000000000)}`

const buildChannelEventObject = (event: string, data?: Data) => {
  const eventId = generateEventId()

  const channelEventObject = {
    member_id: null,
    event: {
      event_name: event,
      facebook_browser_id: getCookie('_fbp'),
      facebook_click_id: getCookie('_fbc'),
      event_time: eventId.split('.')[0],
      event_id: eventId,
      event_source_url:
        window.location.origin +
        window.location.pathname +
        window.location.search +
        window.location.hash,
      action_source: 'website',
      client_user_agent: navigator.userAgent,
      meta_test_event_code: getCookie('cl_meta_event_code'),
    } as CreateChannelEventPayload['event'],
  }

  switch (event) {
    // 'fundraising-page/create/complete', 'fundraising-page/create/complete',
    // 'donation/create/complete', 'registration/create/begin',
    // 'registration/create/complete', ''recurring-donation/create/complete',
    // are currently not being used in the code. There is no mention to
    // .track('[theseEvents]') in the code.

    case 'fundraising-page/create/complete':
      channelEventObject.event.meta_event_name = 'CompleteRegistration'
      channelEventObject.event.content_name = 'Fundraising Page Signup'
      break

    case 'donation/create/begin':
    case 'begin_checkout':
      channelEventObject.event.meta_event_name = 'InitiateCheckout'
      break

    case 'donation/create/complete':
      channelEventObject.event.meta_event_name = 'Purchase'
      channelEventObject.event.content_name = 'Donation'
      channelEventObject.event.content_category = 'one-time'
      channelEventObject.event.value = data?.amount ?? 0
      channelEventObject.event.currency = data?.currency ?? 'USD'
      break

    case 'registration/create/begin':
      channelEventObject.event.meta_event_name = 'AddToCart'
      channelEventObject.event.content_name = 'Registration'
      channelEventObject.event.value = data?.amount ?? 0
      channelEventObject.event.currency = data?.currency ?? 'USD'
      channelEventObject.event.items = data ? calculateNumOfItems(data) : 0
      break

    case 'registration/create/complete':
      channelEventObject.event.meta_event_name = 'CompleteRegistration'
      channelEventObject.event.content_name = 'Registration'
      channelEventObject.event.value = data?.amount ?? 0
      channelEventObject.event.currency = data?.currency ?? 'USD'
      channelEventObject.event.items = data ? calculateNumOfItems(data) : 0
      channelEventObject.event.donation_frequency = data?.donation_frequency ?? ''
      break

    case 'recurring-donation/create/complete':
      channelEventObject.event.meta_event_name = 'Purchase'
      channelEventObject.event.content_name = 'Donation'
      channelEventObject.event.content_category = 'recurring'
      channelEventObject.event.value = data?.amount ?? 0
      channelEventObject.event.currency = data?.currency ?? 'USD'
      break

    case 'ViewContent':
      channelEventObject.event.meta_event_name = 'ViewContent'
      channelEventObject.event.content_name = data?.title

      channelEventObject.event.content_url =
        window.location.origin +
        window.location.pathname +
        window.location.search +
        window.location.hash

      break

    case 'Purchase':
      channelEventObject.event.meta_event_name = 'Purchase'
      channelEventObject.event.content_name = 'Donation'
      channelEventObject.event.content_category = data?.donation_frequency ?? ''
      channelEventObject.event.value = data?.amount ?? 0
      channelEventObject.event.currency = data?.currency ?? 'USD'
      break

    default:
      break
  }

  return channelEventObject
}

export default buildChannelEventObject
